export default {"src":"/_next/static/media/firebase.a770a506.svg","height":351,"width":256,"blurWidth":0,"blurHeight":0};